export default __webpack_public_path__ + "static/media/6101.43bae798.svg";